export * from './src/people.data';
export * from './src/photo.display';
export * from './src/simple.people.display';